import { render, staticRenderFns } from "./ChannelPermission.vue?vue&type=template&id=598d6b26&scoped=true&"
import script from "./ChannelPermission.vue?vue&type=script&lang=js&"
export * from "./ChannelPermission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598d6b26",
  null
  
)

export default component.exports